import { AnswerType, Override, Question, QuestionType } from "@types-runway/questionnaire";

export class QuestionOverrideDTO implements Question {
  question: string;
  answer: AnswerType;
  type: QuestionType;
  important: boolean;
  overriden?: boolean;

  constructor(override: Override, answer: AnswerType) {
    this.question = override.title;
    this.answer = this.containsISODate(answer)
      ? this.convertISODateToMMDDYYYY(answer.toString())
      : answer.toString();
    this.type =
      typeof answer === "string"
        ? "string"
        : typeof JSON.parse(`${answer}`) === "boolean"
          ? "boolean"
          : "number";
    this.important = true;
    this.overriden = true;
  }

  private containsISODate(answer: AnswerType): boolean {
    if (typeof answer !== "string") return false;

    // Check for ISO date format (YYYY-MM-DD)
    const isoDatePattern =
      /\b\d{4}-\d{2}-\d{2}(?:T\d{2}:\d{2}:\d{2}(?:\.\d+)?(?:Z|[+-]\d{2}:\d{2})?)?\b/;

    return isoDatePattern.test(answer);
  }

  private convertISODateToMMDDYYYY(isoDate: string): string {
    const date = new Date(isoDate);
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const day = String(date.getDate()).padStart(2, "0");
    const year = date.getFullYear();
    return `${month}/${day}/${year}`;
  }
}
